/* eslint-disable */
export default {
  title: 'Audio',
  input: 'Eingabe',
  microphone: 'Mikrofon',
  autoAdjustMicLevel: 'Mikrofonlautstärke automatisch anpassen',
  output: 'Ausgabe',
  speakerSource: 'Lautsprecherquelle',
  speakerVolume: 'Lautsprecherlautstärke',
  ringtoneSource: 'Rufton- und Benachrichtigungsquelle',
  ringtoneVolume: 'Rufton- und Benachrichtigungslautstärke',
  ringtones: 'Ruftöne',
  noDevices: 'Keine Geräte',
  off: 'Aus',
  noLabel: 'Unbekanntes Gerät',
  stopRecordDescription:
    'Sagen Sie etwas, um Ihren Mikrofonpegel zu testen ({countDown} Sek.)',
  stopPlaybackDescription: 'Wiedergabe Ihrer Aufzeichnung ...',
  startRecordButton: 'Mikrofon testen',
  stopRecordButton: 'Aufzeichnung beenden',
  stopPlaybackButton: 'Test beenden',
  startTestButton: 'Lautsprecher testen',
  stopTestDescription: 'Beispielton abspielen...',
} as const;

// @key: @#@"title"@#@ @source: @#@"Audio"@#@
// @key: @#@"input"@#@ @source: @#@"Input"@#@
// @key: @#@"microphone"@#@ @source: @#@"Microphone"@#@
// @key: @#@"autoAdjustMicLevel"@#@ @source: @#@"Automatically adjust my mic level"@#@
// @key: @#@"output"@#@ @source: @#@"Output"@#@
// @key: @#@"speakerSource"@#@ @source: @#@"Speaker source"@#@
// @key: @#@"speakerVolume"@#@ @source: @#@"Speaker volume"@#@
// @key: @#@"ringtoneSource"@#@ @source: @#@"Ringtone and notification source"@#@
// @key: @#@"ringtoneVolume"@#@ @source: @#@"Ringtone and notification volume"@#@
// @key: @#@"ringtones"@#@ @source: @#@"Ringtones"@#@
// @key: @#@"noDevices"@#@ @source: @#@"No devices"@#@
// @key: @#@"off"@#@ @source: @#@"Off"@#@
// @key: @#@"noLabel"@#@ @source: @#@"Unknown device"@#@
// @key: @#@"stopRecordDescription"@#@ @source: @#@"Say something to check your mic level ({countDown} sec)"@#@
// @key: @#@"stopPlaybackDescription"@#@ @source: @#@"Playing your recording..."@#@
// @key: @#@"startRecordButton"@#@ @source: @#@"Test microphone"@#@
// @key: @#@"stopRecordButton"@#@ @source: @#@"Stop recording"@#@
// @key: @#@"stopPlaybackButton"@#@ @source: @#@"Stop test"@#@
// @key: @#@"startTestButton"@#@ @source: @#@"Test speaker"@#@
// @key: @#@"stopTestDescription"@#@ @source: @#@"Playing sample sound..."@#@
